import { defineMessages } from 'react-intl';

/** The copy of Settings → Outreach → Mailboxes (design outreach-v2 j1 to j3). Mailboxes are not Plug. */
export const mailboxMessages = defineMessages({
  tabLabel: { id: 'app.sml.settings.tab.outreach', defaultMessage: 'Outreach' },
  tabSubtitle: {
    id: 'app.sml.settings.outreach.subtitle',
    defaultMessage: 'The mailboxes your pitches go from. Replies come back to them.',
  },
  yourMailboxes: { id: 'app.outreach.mailboxes.title', defaultMessage: 'Mailboxes' },
  usage: { id: 'app.outreach.mailboxes.usage', defaultMessage: '{count} of {limit} on your plan' },
  // design outreach-v2 q1, q4: any member connects; only the owner changes or removes.
  memberNote: {
    id: 'app.outreach.mailboxes.member.note',
    defaultMessage:
      'You can connect a mailbox and use it. Only {owner}, the workspace owner, can change or remove one.',
  },
  memberNoteNoOwner: {
    id: 'app.outreach.mailboxes.member.noteNoOwner',
    defaultMessage: 'You can connect a mailbox and use it. Only the workspace owner can change or remove one.',
  },

  // The more menu (design q2).
  sendTest: { id: 'app.outreach.mailboxes.sendTest', defaultMessage: 'Send a test pitch to me' },
  testSent: { id: 'app.outreach.mailboxes.testSent', defaultMessage: 'We sent a test pitch to {to}.' },
  testFailed: {
    id: 'app.outreach.mailboxes.testFailed',
    defaultMessage: 'The test pitch did not go out. Check the mailbox and try again.',
  },
  pause: { id: 'app.outreach.mailboxes.pause', defaultMessage: 'Pause sending' },
  changePassword: { id: 'app.outreach.mailboxes.changePassword', defaultMessage: 'Change the password' },
  resume: { id: 'app.outreach.mailboxes.resume', defaultMessage: 'Resume' },
  remove: { id: 'app.outreach.mailboxes.remove', defaultMessage: 'Remove' },
  removeConfirm: {
    id: 'app.outreach.mailboxes.removeConfirm',
    defaultMessage: 'Remove {address}? Waiting pitches from it stay unsent until you pick another mailbox.',
  },
  actions: { id: 'app.outreach.mailboxes.actions', defaultMessage: 'Actions for {address}' },
  pausedTitle: { id: 'app.outreach.mailboxes.paused.title', defaultMessage: 'We paused this mailbox to protect it.' },
  pausedBySupportBody: {
    id: 'app.outreach.mailboxes.paused.bySupport',
    defaultMessage: 'MUSIC24 support paused this mailbox. Write to support to send from it again.',
  },
  pausedBody: {
    id: 'app.outreach.mailboxes.paused.body',
    defaultMessage:
      'Too many emails bounced or someone marked a pitch as spam. Resume it at a slower pace, or send from another mailbox.',
  },
  reconnectTitle: {
    id: 'app.outreach.mailboxes.reconnect.title',
    defaultMessage: 'The sign-in of this mailbox stopped working.',
  },
  legacyRequestBody: {
    id: 'app.outreach.mailboxes.legacyRequest.body',
    defaultMessage: 'MUSIC24 no longer sets up mailboxes. Remove this one and connect your own mailbox below.',
  },

  connect: { id: 'app.outreach.mailboxes.connect.button', defaultMessage: 'Connect your mailbox' },
  actionFailed: {
    id: 'app.outreach.mailboxes.actionFailed',
    defaultMessage: 'The change did not save. Try again.',
  },
  // Mailboxes card v3 (design outreach-v2 q1 to q4).
  subtitle: {
    id: 'app.outreach.mailboxes.v3.subtitle',
    defaultMessage: 'Pitches go from these addresses. Replies come back to them.',
  },
  webHost: { id: 'app.outreach.mailboxes.v3.webHost', defaultMessage: 'Your web host' },
  googleWorkspace: { id: 'app.outreach.mailboxes.v3.googleWorkspace', defaultMessage: 'Google Workspace' },
  // The line under the address. `{name}` is the email of the user.
  addedByYou: { id: 'app.outreach.mailboxes.v3.addedByYou', defaultMessage: '{provider} · added by you on {date}' },
  addedByOwner: {
    id: 'app.outreach.mailboxes.v3.addedByOwner',
    defaultMessage: '{provider} · added by {name} (owner) on {date}',
  },
  addedByMember: {
    id: 'app.outreach.mailboxes.v3.addedByMember',
    defaultMessage: '{provider} · added by {name} (member) on {date}',
  },
  connectedOn: { id: 'app.outreach.mailboxes.v3.connectedOn', defaultMessage: '{provider} · connected on {date}' },
  warmupDay: { id: 'app.outreach.mailboxes.v3.warmupDay', defaultMessage: 'Warm-up <b>day {day}</b> of {total}' },
  sentToday: { id: 'app.outreach.mailboxes.v3.sentToday', defaultMessage: '<b>{sent} of {cap}</b> sent today' },
  perDayCap: { id: 'app.outreach.mailboxes.v3.perDayCap', defaultMessage: '{cap} a day' },
  nextCap: { id: 'app.outreach.mailboxes.v3.nextCap', defaultMessage: '<b>{cap} a day</b> from {date}' },
  ready: { id: 'app.outreach.mailboxes.v3.ready', defaultMessage: 'Ready' },
  notSending: { id: 'app.outreach.mailboxes.v3.notSending', defaultMessage: 'Not sending' },
  chartLabel: {
    id: 'app.outreach.mailboxes.v3.chartLabel',
    defaultMessage: 'Warm-up: up to {cap} emails a day today, {max} a day at the end',
  },
  statusOk: { id: 'app.outreach.mailboxes.v3.status.ok', defaultMessage: 'Healthy' },
  statusWarming: { id: 'app.outreach.mailboxes.v3.status.warming', defaultMessage: 'Warming up' },
  statusPaused: { id: 'app.outreach.mailboxes.v3.status.paused', defaultMessage: 'Paused' },
  statusReconnect: { id: 'app.outreach.mailboxes.v3.status.reconnect', defaultMessage: 'Sign-in failed' },
  statusProvisioning: { id: 'app.outreach.mailboxes.v3.status.provisioning', defaultMessage: 'Being set up' },
  pausedHealthBody: {
    id: 'app.outreach.mailboxes.v3.paused.healthBody',
    defaultMessage:
      'Too many pitches bounced or someone marked one as spam. Check the address list, then start it again. It sends {cap} a day for {days} days after a restart.',
  },
  pausedByYouTitle: { id: 'app.outreach.mailboxes.v3.paused.ownerTitle', defaultMessage: 'Sending is paused.' },
  pausedByYouBody: {
    id: 'app.outreach.mailboxes.v3.paused.ownerBody',
    defaultMessage: 'The workspace owner paused this mailbox. Resume it to send pitches again.',
  },
  reconnectV3Body: {
    id: 'app.outreach.mailboxes.v3.reconnect.body',
    defaultMessage: 'The password changed or was removed. Type a new app password to send again.',
  },
  typeNewPassword: { id: 'app.outreach.mailboxes.v3.reconnect.button', defaultMessage: 'Type a new password' },
  serverAnswer: { id: 'app.outreach.mailboxes.v3.serverAnswer', defaultMessage: 'The server answered: {error}' },
  addTitle: { id: 'app.outreach.mailboxes.v3.add.title', defaultMessage: 'Connect another mailbox' },
  addBody: {
    id: 'app.outreach.mailboxes.v3.add.body',
    defaultMessage:
      '{count, plural, one {# more fits} other {# more fit}} on your plan. More mailboxes send more pitches each day.',
  },
  addButton: { id: 'app.outreach.mailboxes.v3.add.button', defaultMessage: 'Connect' },
  emptyTitle: { id: 'app.outreach.mailboxes.v3.empty.title', defaultMessage: 'Connect the email you pitch from' },
  emptyBody: {
    id: 'app.outreach.mailboxes.v3.empty.body',
    defaultMessage: 'Curators answer real people. Connect Gmail, iCloud or your own domain. It takes about 2 minutes.',
  },
  slowTitle: { id: 'app.outreach.mailboxes.v3.slow.title', defaultMessage: 'Why we start slowly' },
  // QA 2026-10-28 skp-15: the ramp is a safety cap of one mailbox, not the pitch number of the plan.
  // The native apps read this id too (scripts/music24-native/i18n-keys.txt): keep its placeholders.
  slowBody: {
    id: 'app.outreach.mailboxes.v3.slow.body',
    defaultMessage:
      'A new mailbox that sends many emails at once lands in spam. So each mailbox has a safety cap: it starts at {first} emails a day and reaches {max} a day after {weeks} weeks. The cap is not the number of pitches of your plan.',
  },
  slowPlanRate: {
    id: 'app.outreach.mailboxes.v4.slow.planRate',
    defaultMessage:
      'Your plan sends {rate, plural, =0 {no new pitches} one {# new pitch} other {# new pitches}} a day for each artist. Each day we send the smaller number: the pitches of your plan or the cap of the mailbox. Follow-ups use the cap, not the pitches of your plan.',
  },
  slowLastChip: { id: 'app.outreach.mailboxes.v3.slow.lastChip', defaultMessage: '{cap} a day' },
  pauseTitle: { id: 'app.outreach.mailboxes.v3.pauseRule.title', defaultMessage: 'When we pause a mailbox' },
  pauseBody: {
    id: 'app.outreach.mailboxes.v3.pauseRule.body',
    defaultMessage:
      'We stop sending when bounces pass {bounce}% or someone marks a pitch as spam. You see why here, and you can start it again.',
  },
  ownerRights: {
    id: 'app.outreach.mailboxes.v3.ownerRights',
    defaultMessage:
      'You are the workspace owner. Members can connect a mailbox and use it. <b>Only you</b> can change or remove one.',
  },
});
